import styled from "styled-components";
export const DealContainer = styled.div `
    padding: 40px;
    height: fit-content;
    @media screen and (max-width: 768px){
        padding: 2px 0;
    }
`
export const DealText = styled.h4 `
    text-transform: uppercase;
    color: #3e4152;
    letter-spacing: .2em;
    font-size: 1.8em;
    text-align: center;
    padding: 2rem;
    max-height: 5em;
    font-weight: 600;
`
export const Name = styled.h6 `
    font-weight: 600;
`
